var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout:5000":"","value":_vm.hasMessage},on:{"input":_vm.closeSnackbar}},[_vm._v(" "+_vm._s(_vm.messageText)+" "),_c('v-btn',{attrs:{"color":"white","text":""},on:{"click":_vm.closeSnackbar}},[_vm._v(" "+_vm._s(_vm.$t('components.snackbar.close'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }